module.exports = __webpack_public_path__ + "img/logo1 (46).5eb7e331.jpg";